module.exports = __webpack_public_path__ + "img/ev.d00d5d46.png";